import axios from '../../axios'

/*
 * 统考信息管理接口
 */

// 创建统考信息
export const createTKInfo = (data) => {
    return axios({
        url: '/api/data/wish/jointexam',
        method: 'POST',
        data
    })
}

// 获取统考信息详情
export const getTKInfomation = (data) => {
    return axios({
        url: '/api/data/wish/jointexam/info',
        method: 'get',
        data
    })
}

// 修改统考信息
export const editTKInfo = (data) => {
    return axios({
        url: '/api/data/wish/jointexam',
        method: 'PUT',
        data
    })
}

// 删除统考信息
export const delTKInfo = (data) => {
    return axios({
        url: '/api/data/wish/jointexam',
        method: 'DELETE',
        data
    })
}

// 获取统考信息列表
export const getTKList = (data) => {
    return axios({
        url: '/api/data/wish/jointexam/list',
        method: 'GET',
        data
    })
}

// 获取统考专业列表
export const getJointList = (data) => {
    return axios({
        url: '/api/data/wish/joint/category',
        method: 'GET',
        data
    })
}

// 根据关键字模糊搜索
export const getPageByKey = (data) => {
    return axios({
        url: '/api/data/wish/search/jointexam',
        method: 'GET',
        data
    })
}

// 根据年份省份获取统考类别列表
export const getJointListByParam = (data) => {
    return axios({
        url: '/api/data/wish/province/joint/category',
        method: 'GET',
        data
    })
}

// 获取自定义导出字段数据
export const getOptionList = (data) => {
    return axios({
        url: '/api/base/column',
        method: 'GET',
        data
    })
}

// 线上计算校文化分控线
export const upgradeCultureLine = (data) => {
    return axios({
        url: '/api/data/wish/syncAdmissionByCondition',
        method: 'GET',
        data
    })
}

// 招生计划统计
export const upPlanNumLine = (data) => {
    return axios({
        url: '/api/data/wish/enroll_plan_data/create',
        method: 'GET',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/tkinfo.js